import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { IApplicationContext } from 'shared/context/applicationContext/types';
import { ApplicationContext } from 'shared/context/applicationContext/applicationContext';
import { TBrowserStore } from '../../types/store';
import { Menu } from '../Menu/Menu';
import { ValidatorButton } from '../ValidatorButton/ValidatorButton';
import { DEVELOPER_VALIDATOR_URL, VALIDATOR_URL } from 'shared/constants/url/validatorURL';
import * as styles from './App.css';

type IApplicationProps = {
  context: IApplicationContext;
  store: TBrowserStore;
};

export const Application = ({ store, context }: IApplicationProps) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  const { hierarchy } = store;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Menu categoriesGroups={hierarchy} />
          <div className={styles['validator-button-wrapper']}>
            <ValidatorButton text="Перейти в валидатор" href={VALIDATOR_URL} />
          </div>
          <ValidatorButton text="Перейти в валидатор для застройщиков" href={DEVELOPER_VALIDATOR_URL} />
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
